export interface Story3StarterPrompt {
  id: string;
  text: string;
}

export const STORY3_STARTER_PROMPTS: Story3StarterPrompt[] = [
  {
    id: 'forest',
    text: 'Noget uventet sker i en skov du kender godt.',
  },
  {
    id: 'school',
    text: 'En dag på skolen tager en helt anden retning end planlagt.',
  },
  {
    id: 'message',
    text: 'Du finder en besked du ikke forstår — hvem har sendt den?',
  },
  {
    id: 'animal',
    text: 'Et dyr du møder, kan noget ingen andre tror på.',
  },
];

export function pickStory3Starter(seed?: number): Story3StarterPrompt | null {
  if (STORY3_STARTER_PROMPTS.length === 0) return null;
  const idx =
    seed !== undefined
      ? Math.abs(seed) % STORY3_STARTER_PROMPTS.length
      : Math.floor(Math.random() * STORY3_STARTER_PROMPTS.length);
  return STORY3_STARTER_PROMPTS[idx] ?? null;
}
